import { useState, useEffect } from 'react';
import api from '../utils/api';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, isSameMonth, isToday, startOfWeek, endOfWeek } from 'date-fns';
import { tr } from 'date-fns/locale';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function CalendarPage() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState({ blocks: [], reservations: [] });

  useEffect(() => {
    const start = startOfMonth(currentDate).toISOString();
    const end = endOfMonth(currentDate).toISOString();
    api.get(`/calendar?start=${start}&end=${end}`).then(setCalendarData).catch(console.error);
  }, [currentDate]);

  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  const calStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const calEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });
  const days = eachDayOfInterval({ start: calStart, end: calEnd });

  const getEventsForDay = (day) => {
    const dayStr = format(day, 'yyyy-MM-dd');
    const reservations = calendarData.reservations.filter(r => {
      const checkIn = format(new Date(r.checkIn), 'yyyy-MM-dd');
      const checkOut = format(new Date(r.checkOut), 'yyyy-MM-dd');
      return dayStr >= checkIn && dayStr < checkOut;
    });
    return reservations;
  };

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Takvim</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn btn-secondary" onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))}>
            <ChevronLeft size={16} />
          </button>
          <span style={{ fontWeight: 600, fontSize: 16, minWidth: 160, textAlign: 'center' }}>
            {format(currentDate, 'MMMM yyyy', { locale: tr })}
          </span>
          <button className="btn btn-secondary" onClick={() => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))}>
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: '1px solid #e2e8f0' }}>
          {['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'].map(d => (
            <div key={d} style={{ padding: '10px 8px', textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#64748b', background: '#f8fafc' }}>{d}</div>
          ))}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
          {days.map((day, i) => {
            const events = getEventsForDay(day);
            const isCurrentMonth = isSameMonth(day, currentDate);
            const today = isToday(day);
            return (
              <div key={i} style={{
                minHeight: 90, padding: '8px', borderRight: (i + 1) % 7 !== 0 ? '1px solid #e2e8f0' : 'none',
                borderBottom: i < days.length - 7 ? '1px solid #e2e8f0' : 'none',
                background: today ? '#eff6ff' : 'white',
                opacity: isCurrentMonth ? 1 : 0.4,
              }}>
                <div style={{ fontSize: 13, fontWeight: today ? 700 : 400, color: today ? '#3b82f6' : '#1e293b', marginBottom: 4 }}>
                  {format(day, 'd')}
                </div>
                {events.slice(0, 2).map(r => (
                  <div key={r.id} style={{ fontSize: 11, padding: '2px 6px', borderRadius: 4, marginBottom: 2, background: r.status === 'CONFIRMED' ? '#dcfce7' : '#fef9c3', color: r.status === 'CONFIRMED' ? '#166534' : '#854d0e', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {r.customerName}
                  </div>
                ))}
                {events.length > 2 && <div style={{ fontSize: 10, color: '#94a3b8' }}>+{events.length - 2} daha</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
